import React, { Component } from 'react'
import moment from 'moment'
import SelectField from './SelectField'
import Checkbox from './Checkbox'
import { DateRangePicker, SingleDatePicker } from 'react-dates'
import { push } from 'datalayer'
import Recaptcha from './Recaptcha'
import { gettext } from 'django'

const accomodationTypes = [
  { value: 'Mobilne kućice', label: gettext('Mobile Home') },
  { value: 'Parcele – Kamper', label: gettext('Camping pitch') + ' - ' + gettext('Camper') },
  { value: 'Parcele – Kamp prikolica', label: gettext('Camping pitch') + ' - ' + gettext('Caravan') },
  { value: 'Parcele – Šator', label: gettext('Camping pitch') + ' - ' + gettext('Tent') }
]
const persons = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' }
]
const checkInTransfer = [
  { value: 'Aerodrom Zadar – Kamp Straško', label: gettext('Aerodrom Zadar – Kamp Straško') },
  { value: 'Zadar - Kamp Straško', label: gettext('Zadar - Kamp Straško') },
  { value: 'Aerodrom Split – Kamp Straško', label: gettext('Aerodrom Split – Kamp Straško') },
  { value: 'Split – Kamp Straško', label: gettext('Split – Kamp Straško') },
  { value: 'Aerodrom Zagreb – Kamp Straško', label: gettext('Aerodrom Zagreb – Kamp Straško') }
]
const checkOutTransfer = [
  { value: 'Kamp Straško – Aerodrom Zadar', label: gettext('Kamp Straško – Aerodrom Zadar') },
  { value: 'Kamp Straško – Zadar', label: gettext('Kamp Straško – Zadar') },
  { value: 'Kamp Straško – Aerodrom Split', label: gettext('Kamp Straško – Aerodrom Split') },
  { value: 'Kamp Straško – Split', label: gettext('Kamp Straško – Split') },
  { value: 'Kamp Straško – Aerodrom Zagreb', label: gettext('Kamp Straško – Aerodrom Zagreb') }
]
const year = moment().year()

if (window.projectName === 'strasko') {
  accomodationTypes.unshift({ value: 'Glamping šator', label: gettext('Glamping Tent') })
}

// Real month values, 1-12
const minMonth = window.projectName === 'strasko' ? 4 : 1
const maxMonth = window.projectName === 'strasko' ? 10 : 12
const minDayOnMinMonth = window.projectName === 'strasko' ? 11 : 1
const maxDayOnMaxMonth = window.projectName === 'strasko' ? 18 : 31
// Last years max date, used to properly set the initial date
// It needs to switch to the next year after it is passed
const maxDateLastYear = moment({ year: year, month: 10 - 1, day: 8 })

export class ReservationForm extends Component {
  state = {
    startDate: null,
    endDate: null,
    checkInTransferDate: null,
    checkOutTransferDate: null,
    focusedInput: null,
    focusedCheckInTransferDate: null,
    focusedCheckOutTransferDate: null,
    schema: {
      accommodation_type: '',
      check_in_day: '',
      check_in_month: '',
      check_in_year: '',
      nights: '',
      adults_count: 0,
      adults_older_count: 0,
      children_older_count: 0,
      children_younger_count: 0,
      pets_count: 0,
      transfer: false,
      check_in_transfer: '',
      check_in_transfer_date: '',
      check_out_transfer: '',
      check_out_transfer_date: ''
    },
    disabled: true,
    showDimensionsField: false,
    dimensionsFieldLabel: ''
  }

  componentWillMount() {
    this.updateWidth()
    window.addEventListener('resize', this.updateWidth.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth.bind(this))
  }

  updateWidth = () => {
    this.setState({ windowWidth: window.innerWidth, focusedInput: null })
  }

  verifyCallback = () => {
    this.setState({ disabled: false })
  }

  expiredCallback = () => {
    this.setState({ disabled: true })
  }

  handleChanges = event => {
    const name = event.target.name
    const value = name === 'transfer' ? event.target.checked : event.target.value
    let schema = this.state.schema
    schema[name] = value

    let showDimensionsField = this.state.showDimensionsField
    let dimensionsFieldLabel = this.state.dimensionsFieldLabel
    if (['Parcele – Kamper', 'Parcele – Kamp prikolica', 'Parcele – Šator'].indexOf(schema.accommodation_type) > -1) {
      // eslint-disable-next-line default-case
      switch (schema.accommodation_type) {
        case 'Parcele – Kamper':
          dimensionsFieldLabel = gettext('Camper size')
          break
        case 'Parcele – Kamp prikolica':
          dimensionsFieldLabel = gettext('Caravan size')
          break
        case 'Parcele – Šator':
          dimensionsFieldLabel = gettext('Tent size')
          break
      }
      showDimensionsField = true
    } else {
      dimensionsFieldLabel = ''
      showDimensionsField = false
    }

    this.setState({ schema, showDimensionsField, dimensionsFieldLabel })
  }

  handleDateChange = ({ startDate, endDate }) => {
    let schema = this.state.schema

    if (startDate) {
      schema.check_in_day = startDate.date()
      schema.check_in_month = startDate.month() + 1
      schema.check_in_year = startDate.year()
    }
    if (startDate && endDate) {
      schema.nights = endDate.diff(startDate, 'days')
    }

    this.setState({ startDate, endDate, schema })
  }

  handleTransferDateChange = (type, date) => {
    let schema = this.state.schema
    schema[type] = date.format('DD.MM.YYYY.')

    let newState = { schema }

    if (type === 'check_in_transfer_date') {
      newState.checkInTransferDate = date
    } else {
      newState.checkOutTransferDate = date
    }

    this.setState(newState)
  }

  handleSubmit = event => {
    if (this.state.schema.accommodation_type === '' || !this.state.startDate || !this.state.endDate) {
      event.preventDefault()
      return false
    }
    push({
      event: 'trackEvent',
      eventCategory: 'Form Submit',
      eventAction: 'Reservation Form',
      eventLabel: 'Success'
    })
  }

  isDayBlocked = date => {
    const day = date.date()
    const month = date.month() + 1
    if (month < minMonth || month > maxMonth) return true
    if (month === minMonth && day < minDayOnMinMonth) return true
    if (month === maxMonth && day > maxDayOnMaxMonth) return true

    return false
  }

  initialVisibleMonth = () => {
    const currentMonth = moment().month() + 1 //returns 0 to 11
    const initialDate = moment()

    if (currentMonth < minMonth) {
      initialDate.month(minMonth - 1)
    } else if (initialDate > maxDateLastYear) {
      initialDate.add(1, 'year').month(minMonth - 1)
    }
    return initialDate
  }

  render = () => (
    <div className={`container with-gap reservation-${window.projectName}`}>
      <form action='#' method='post' id='phobs_book' name='phobs_book' onSubmit={this.handleSubmit}>
        <div className='columns'>
          <div className='column booking-wrapper'>
            <div className='columns'>
              <div className='column is-6-desktop is-offset-3-desktop'>
                <div className='columns'>
                  <div className='column'>
                    <h3>{gettext('Booking request')}</h3>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='first-name'>
                      <label>{gettext('First name')}</label>
                      <input name='first_name' required></input>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='last-name'>
                      <label>{gettext('Last name')}</label>
                      <input name='last_name' required></input>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='email'>
                      <label>{gettext('Email address')}</label>
                      <input
                        name='email'
                        type='email'
                        pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"
                        required
                      ></input>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='accomodation-type'>
                      <label>{gettext('Accommodation type')}</label>
                      <SelectField
                        name='accommodation_type'
                        placeholder={gettext('Select accommodation type')}
                        displayProp='label'
                        valueProp='value'
                        options={accomodationTypes}
                        changeCallback={this.handleChanges}
                        value={this.state.schema.accommodation_type}
                        caretColor={this.props.caretColor}
                      />
                    </div>
                  </div>
                </div>

                {this.state.showDimensionsField && (
                  <div className='columns'>
                    <div className='column'>
                      <div className='dimensions'>
                        <label>{this.state.dimensionsFieldLabel}</label>
                        <input name='dimensions' required></input>
                      </div>
                    </div>
                  </div>
                )}

                <div className='columns'>
                  <div className='column'>
                    <div className='dates'>
                      <div className='columns'>
                        <div className='column picker-button'>
                          <div className={`datepicker-${window.projectName}`}>
                            <div className='dates-labels'>
                              <label>{gettext('Arrival')}</label>
                              <label>{gettext('Departure')}</label>
                            </div>
                            <DateRangePicker
                              openDirection='down'
                              startDatePlaceholderText={gettext('Arrival')}
                              endDatePlaceholderText={gettext('Departure')}
                              startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                              startDateId='start_date' // PropTypes.string.isRequired,
                              endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                              endDateId='end_date' // PropTypes.string.isRequired,
                              onDatesChange={this.handleDateChange} // PropTypes.func.isRequired,
                              focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                              onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired
                              firstDayOfWeek={1}
                              numberOfMonths={this.state.windowWidth >= 769 ? 2 : 1}
                              displayFormat='DD/MM/YYYY'
                              isDayBlocked={this.isDayBlocked}
                              initialVisibleMonth={this.initialVisibleMonth}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className={`column is-${window.projectName === 'strasko' ? 4 : 6}`}>
                    <div className='persons'>
                      <label>{gettext('Adults (over 12 years)')}</label>
                      <SelectField
                        name='adults_count'
                        placeholder=''
                        displayProp='label'
                        valueProp='value'
                        options={persons}
                        changeCallback={this.handleChanges}
                        value={this.state.schema.adults_count}
                      />
                    </div>
                  </div>
                  {window.projectName === 'strasko' && (
                    <div className='column is-4 second-child'>
                      <div className='persons'>
                        <label>{gettext('Adults (over 60 years)')}</label>
                        <SelectField
                          name='adults_older_count'
                          placeholder=''
                          displayProp='label'
                          valueProp='value'
                          options={persons}
                          changeCallback={this.handleChanges}
                          value={this.state.schema.adults_older_count}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    className={`column is-${window.projectName === 'strasko' ? 4 : 6} ${
                      window.projectName === 'strasko' ? 'third' : 'second'
                    }-child`}
                  >
                    <div className='persons'>
                      <label>{gettext('Children (from 7 to 12 years)')}</label>
                      <SelectField
                        name='children_older_count'
                        placeholder=''
                        displayProp='label'
                        valueProp='value'
                        options={persons}
                        changeCallback={this.handleChanges}
                        value={this.state.schema.children_older_count}
                      />
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column is-6'>
                    <div className='persons'>
                      <label>{gettext('Children (up to 6,99 years)')}</label>
                      <SelectField
                        name='children_younger_count'
                        placeholder=''
                        displayProp='label'
                        valueProp='value'
                        options={persons}
                        changeCallback={this.handleChanges}
                        value={this.state.schema.children_younger_count}
                      />
                    </div>
                  </div>
                  <div className='column is-6 second-child'>
                    <div className='persons pets'>
                      <label>{gettext('Pets')}</label>
                      <SelectField
                        name='pets_count'
                        placeholder=''
                        displayProp='label'
                        valueProp='value'
                        options={persons}
                        changeCallback={this.handleChanges}
                        value={this.state.schema.pets_count}
                      />
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <div className='note'>
                      <label>{gettext('Note')}</label>
                      <textarea name='note'></textarea>
                    </div>
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <Recaptcha
                      sitekey='6LfN-2MrAAAAAGQ6SwS4ObX9OLKGFqo05Xrzq_K_'
                      render='explicit'
                      verifyCallback={this.verifyCallback}
                      expiredCallback={this.expiredCallback}
                    />
                  </div>
                </div>

                <div className='columns'>
                  <div className='column'>
                    <button type='submit' className='btn-blue' disabled={this.state.disabled}>
                      {gettext('Send')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <input name='check_in_day' type='hidden' style={{ display: 'none' }} value={this.state.schema.check_in_day} />
        <input
          name='check_in_month'
          type='hidden'
          style={{ display: 'none' }}
          value={this.state.schema.check_in_month}
        />
        <input name='check_in_year' type='hidden' style={{ display: 'none' }} value={this.state.schema.check_in_year} />
        <input name='nights' type='hidden' style={{ display: 'none' }} value={this.state.schema.nights} />
        <input
          name='csrfmiddlewaretoken'
          type='hidden'
          style={{ display: 'none' }}
          value={window.RESERVATION_CSRF_TOKEN}
        />
      </form>
    </div>
  )
}

export default ReservationForm



// WEBPACK FOOTER //
// ./src/js/ReservationForm.js